var map = {
	"./academic.svg": "VQvG",
	"./address.svg": "Tunl",
	"./again.svg": "ZsCz",
	"./android.svg": "X/Bg",
	"./arrow-grey.svg": "ZHz1",
	"./arrow.svg": "7Hhe",
	"./audio.svg": "rOpi",
	"./book-magazine.svg": "GAQN",
	"./book-open.svg": "vlHh",
	"./book.svg": "fVuw",
	"./borrow.svg": "6VNK",
	"./call.svg": "v68m",
	"./cardInstructions.svg": "jZFK",
	"./cartoon.svg": "4tYj",
	"./collection.svg": "UObD",
	"./date.svg": "Fgz+",
	"./delete.svg": "eXS7",
	"./down.svg": "Fdmw",
	"./exit.svg": "usid",
	"./guide.svg": "QspO",
	"./guide1.svg": "th4P",
	"./guide2.svg": "TrIf",
	"./guide3.svg": "tWnm",
	"./guide4.svg": "4tCn",
	"./guide5.svg": "VdNW",
	"./guide6.svg": "TDJh",
	"./guide7.svg": "FGEo",
	"./history.svg": "98VZ",
	"./inLibrary.svg": "RCcK",
	"./information.svg": "Yuu7",
	"./integral.svg": "WIxY",
	"./introduce.svg": "xKes",
	"./iphone.svg": "hSRL",
	"./journal.svg": "Y0DE",
	"./listShare.svg": "o0P/",
	"./logout.svg": "fmgo",
	"./message.svg": "XMA+",
	"./nav1.svg": "du0U",
	"./nav10.svg": "Yg/E",
	"./nav11.svg": "GSZU",
	"./nav12.svg": "Css3",
	"./nav13.svg": "TLdA",
	"./nav2.svg": "xvI3",
	"./nav3.svg": "pzI5",
	"./nav4.svg": "rmqp",
	"./nav5.svg": "2V2j",
	"./nav6.svg": "/N6I",
	"./nav7.svg": "JcsE",
	"./nav8.svg": "abOZ",
	"./nav9.svg": "wv+q",
	"./no-collect.svg": "6AJb",
	"./notice.svg": "qyfJ",
	"./openTime.svg": "7dtY",
	"./order.svg": "ZDHJ",
	"./personal.svg": "ug0u",
	"./qq.svg": "IaA/",
	"./question.svg": "xCI5",
	"./refresh.svg": "i+qi",
	"./res-audio.svg": "JKTy",
	"./res-video.svg": "N7ue",
	"./resources.svg": "5OpT",
	"./return.svg": "08oB",
	"./sel-collect.svg": "cogr",
	"./set.svg": "xqRR",
	"./share.svg": "2lPY",
	"./subscribe.svg": "pMuO",
	"./time.svg": "oA2k",
	"./trailer-exhibition.svg": "WXeN",
	"./trailer-notice.svg": "+xLB",
	"./trailer-show.svg": "bJk8",
	"./trailer-train.svg": "IbeV",
	"./update.svg": "Hrty",
	"./wb.svg": "x+Ju",
	"./wx.svg": "FEmj"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "/tJe";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons nonrecursive \.svg$
// module id = /tJe
// module chunks = 3